import { getCookie } from 'cookies-next';

/**
 * @returns {boolean} - Returns true if analytics should be suppressed, otherwise false.
 */
export const isAnalyticsSuppressed = (): boolean => {
  return Boolean(getCookie('suppress-analytics'));
};
